import React, { useEffect, useState } from "react";

import { BlogCategoriesWrapper, ListWrapper } from "./style";

import {
	BUTTON_INTERACTION,
	handleCTAClick,
	replaceCharWith,
} from "@website-builder/utilities-index";
import { getStoriesByContentType } from "@website-builder/services";
import { contentType, getBlogCategories } from "./transform";
import { Text, Link, Accordion } from "@website-builder/ui/shared/elements";

const BlogCategories = ({ categoriesMap, context }) => {
	const [categoriesMapState, setCategoriesMapState] = useState(categoriesMap);
	const isHeaderSticky = context.isHeaderSticky || false;

	useEffect(() => {
		if (process.env.GATSBY_TEMPLATE === "PREVIEW") {
			async function fetchData() {
				const pagination = "100";
				const { token } = context;
				let result = await getStoriesByContentType(
					contentType,
					token && token.private,
					pagination,
				);
				result = getBlogCategories(result);
				setCategoriesMapState(result);
			}
			fetchData();
		}
	}, []);

	const blogCategoriesContent = (() => {
		let categories = Object.keys(categoriesMapState);
		return categories.map((category, index) => {
			const link = `/${categoriesMapState[category]["filterSlug"]}`;
			const linkText = category
				.split("-")
				.map((word) =>
					word.length < 3
						? word.toUpperCase()
						: word.charAt(0).toUpperCase() + word.slice(1),
				)
				.join(" ");
			const cta = {
				link: {
					type: "internal",
					link: link,
					target: "_self",
				},
				event: BUTTON_INTERACTION.LINK_CLICK,
			};
			const eventData = {
				page_section: "BlogCategories",
				redirect_to: link,
				click_text: linkText,
			};

			const isActiveLink = (() => {
				const contextSlug = context.full_slug;
				const contextSlugArr = contextSlug
					.split("/")
					.filter((item) => item !== "");
				const linkSlugArr = link.split("/").filter((item) => item !== "");
				return (
					contextSlugArr.length === linkSlugArr.length &&
					linkSlugArr.every((item, i) => item === contextSlugArr[i])
				);
				// Check if url in link is the same as full slug, while ignoring any changes that may happen due to "/" characters
			})();

			return (
				<Link
					onClick={(e) => handleCTAClick(cta, eventData, {}, e)}
					key={index}
					className={`blog-category-link ${
						isActiveLink ? "blog-category-link-active" : null
					}`}
					target="_self"
					href={link}
				>
					<Text variant="paragraph_L">{linkText}</Text>
				</Link>
			);
		});
	})();

	const headingStyles = {
		fontFamily: "var(--theme-ff)",
		color: "var(--secondary-gray-dark)",
	};

	return (
		<BlogCategoriesWrapper isHeaderSticky={isHeaderSticky}>
			<div className="blog-categories-desktop">
				<Text variant="label_L" style={headingStyles}>
					Categories
				</Text>
				<ListWrapper>{blogCategoriesContent}</ListWrapper>
			</div>
			<div className="blog-categories-mobile">
				<Accordion
					accordionItems={[
						{
							heading: (
								<Text variant="label_L" style={headingStyles}>
									Categories
								</Text>
							),
							content: (
								<ListWrapper mobileMode={true}>
									{blogCategoriesContent}
								</ListWrapper>
							),
						},
					]}
					icon="plusMinus"
					showItemTopSeparator={false}
					accordionHeadingClassName="blog-categories-mobile-heading"
					accordionContentClassName="blog-categories-mobile-content"
				></Accordion>
			</div>
		</BlogCategoriesWrapper>
	);
};

export default BlogCategories;
